import { BRANCHIO_TOKEN } from '@/constants/TrackingConstants'
import branch from 'branch-sdk'

const branchio = branch.init(BRANCHIO_TOKEN)

export default branchio
